import { render, staticRenderFns } from "./OperaBikesWindow.vue?vue&type=template&id=12908c4c&"
import script from "./OperaBikesWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBikesWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports